import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/solution/on-demand-new/cta_back.webp";
import { StaticImage } from "gatsby-plugin-image";

function Custombrand() {
  return (
    <section
      className="custom_brand p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="resp_order">
            <StaticImage
              src="../../images/solution/on-demand-new/on_demand_brand_new.webp"
              alt="On-demand mobile application"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={485}
              height={398}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <h2>
              Looking for an On-Demand Mobile Application to Transform{" "}
              <span>Brand Interaction?</span>
            </h2>
            <p>Consult TekRevol for On-Demand App Development Services.</p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book a call
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Custombrand;
